import { EntityItem } from "../../entity/EntityItem";

export class DtoItemsPutRes extends EntityItem {}
